import { Action } from '../../generalTypes';
import { SET_RANGE_DATA } from '../actionConstants';

export const actionSetRangeData = (key: string, value: any): Action<any> => ({
  type: SET_RANGE_DATA,
  payload: {
    key,
    value,
  },
});
